import { Component, OnInit } from '@angular/core';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { ExportacaoAgenteFinanceiroService } from './exportacao-agente-financeiro.service';
import { ExportacaoGestorService } from './exportacao-gestor.service';

@Component({
    selector: 'app-empresas-bloqueadas',
    templateUrl: './empresas-bloqueadas.component.html',
    styleUrls: ['./empresas-bloqueadas.component.scss'],
    standalone: false
})
export class EmpresasBloqueadasComponent implements OnInit {

    private exportacaoGestor: boolean;

    constructor(private fileUtils: FileUtilsService,
        private permissaoService: PermissaoService,
        private agenteService: ExportacaoAgenteFinanceiroService,
        private gestorService: ExportacaoGestorService) {
    }

    ngOnInit(): void {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            if (resp && resp[ROLE_GESTOR_CONSULTA]) {
                this.exportacaoGestor = true;
            }
        });
    }

    baixarEmpresasBloqueadas() {
        if (this.exportacaoGestor) {
            this.gestorService.getEmpresasBloqueadas().subscribe((conteudoArquivo) => {
                this.fileUtils.exportarArquivoUTF8('empresas_bloqueadas.csv',
                    conteudoArquivo, FileUtilsService.TEXT_CSV);
              });
        }
        else {
            this.agenteService.getEmpresasBloqueadas().subscribe((conteudoArquivo) => {
                this.fileUtils.exportarArquivoUTF8('empresas_bloqueadas.csv',
                    conteudoArquivo, FileUtilsService.TEXT_CSV);
              });
        }
    }

}